import React from 'react'
import Header from '../inc/Header'
import {Link} from "react-router-dom";
import ContactForm from './ContactForm';

function Applyfanchisee() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      

        <div className='newback'>
            <div className="album py-1">
                <div className="container mt-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Apply for Franchisee</li>
                        </ol>
                    </nav>
                </div>
                </div>
            </div>
            
            <div className='iccreamkrishnagar'>
            <br/>
                <br/>
                <div className="album py-0">
        <div className="container">
          <center>
            <h3 style={{color:"maroon"}}><b>Franchisee Application</b></h3>
          <h6 className='mb-4'>Enter your Details for identity verification and Franchisee processing.</h6>

          </center>
          </div>
          </div>
           <div className="container">
        <ContactForm/>
        </div>
        <br/>
        </div>
    </div>
  )
}

export default Applyfanchisee